import { Component, Input, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { filter } from 'rxjs/operators';

import { CognitoService } from '../../services/cognito.service';
import { LabelService } from '../../services/label.service';
import { OutsideClickDirective } from '../../directives/outside-click.directive';
import { TaxonomyListComponent } from '../../pages/taxonomy-dashboard-v2/taxonomy-list/taxonomy-list.component';
import { TaxonomyActionsComponent } from '../../pages/taxonomy-dashboard-v2/taxonomy-actions/taxonomy-actions.component';
import { TaxonomyService } from '../../services/taxonomy.service';
import { HeaderConfig } from '../../shared/types';
import { TaxonomyVersionActionsComponent } from '../../pages/taxonomy-dashboard-v2/taxonomy-version-actions/taxonomy-version-actions.component';
import { RoutePersistenceService } from '../../services/route-persistence.service';

@Component({
  selector: 'app-taxonomy-header',
  standalone: true,
  imports: [OutsideClickDirective, TaxonomyListComponent, TaxonomyActionsComponent, TaxonomyVersionActionsComponent],
  templateUrl: './taxonomy-header.component.html',
  styleUrl: './taxonomy-header.component.scss',
})
export class TaxonomyHeaderComponent implements OnInit {
  @Input() config: HeaderConfig = {
    title: '',
  };
  showDropdown: boolean = false;
  showTabWrapper: boolean = false;
  selectedTabIndex: number = 0;

  constructor(
    private router: Router,
    private cognitoService: CognitoService,
    public labelService: LabelService,
    private location: Location,
    public taxonomyService: TaxonomyService,
    private routePersistenceService: RoutePersistenceService
  ) {
    // Listen to route changes and update tab wrapper visibility
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.checkRouteAndSetTabWrapper();
      });
  }

  ngOnInit(): void {
    this.checkRouteAndSetTabWrapper();
  }

  clickLogout() {
    this.router.navigate(['login']);
    this.showDropdown = false;
    localStorage.clear();
    try {
      sessionStorage.clear();
    } catch (e) {
      // ignore
    }
    this.routePersistenceService.clearSavedRoute();
    this.cognitoService.deleteCookies();
    this.cognitoService.clearCookies();
    localStorage.removeItem('authToken');
  }

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  onOutsideClick = () => {
    this.showDropdown = false;
  };

  handleBackPress() {
    const currentPath = this.router.url;

    const id = currentPath.replace('/taxonomy-dashboard/', '');
    if (currentPath.startsWith('/taxonomy-dashboard/') && id.trim().length > 0) {
      sessionStorage.removeItem('selectedTaxonomy');
      this.router.navigate(['/taxonomy-dashboard']);
    } else {
      this.location.back();
    }
  }

  taxoSettingsFlag = false;

  toggleSettings() {
    this.taxoSettingsFlag = true;

    if (this.taxoSettingsFlag) {
      this.router.navigate(['settings']);
    } else {
      this.router.navigate(['taxonomy-dashboard']);
    }
  }

  /**
   * Check the current route and set tab wrapper visibility and selected tab
   */
  private checkRouteAndSetTabWrapper(): void {
    const currentRoute = this.router.url;

    // Show tab wrapper only for main taxonomy dashboard routes
    if (
      currentRoute.includes('/taxonomy-dashboard/all-taxonomies') ||
      currentRoute.includes('/taxonomy-dashboard/playground') ||
      currentRoute === '/taxonomy-dashboard'
    ) {
      this.showTabWrapper = true;

      // Set the selected tab based on the route
      if (currentRoute.includes('/taxonomy-dashboard/all-taxonomies')) {
        this.selectedTabIndex = 0;
      } else if (currentRoute.includes('/taxonomy-dashboard/playground')) {
        this.selectedTabIndex = 1;
      } else if (currentRoute === '/taxonomy-dashboard') {
        this.selectedTabIndex = 0; // Default to All Taxonomies
      }
    } else {
      this.showTabWrapper = false;
    }
  }

  /**
   * Handle tab change and navigate to the appropriate route
   */
  onTabChange(index: number): void {
    this.selectedTabIndex = index;

    // Update the URL based on the selected tab
    if (index === 0) {
      this.router.navigate(['/taxonomy-dashboard/all-taxonomies']);
    } else if (index === 1) {
      this.router.navigate(['/taxonomy-dashboard/playground']);
    }
  }
}
